import React, {useState, useCallback} from 'react'
import {
  FaEnvelope, FaPhone, FaFacebookF, FaYoutube,
  // FaLinkedinIn, FaInstagram,
} from 'react-icons/fa'
import {includes} from 'lodash-es'
import cn from 'classnames'
import produce from 'immer'

// Components
import Header from './Header.styled'

// Constants
import {
  BLOG_DETAILS, BLOG_LIST, CATEGORY, CONSIGNMENT, DETAILS, NOT_FOUND, RENT_BY_DISTRICT, RENT_PAGE, SALE_BY_DISTRICT, SALE_PAGE, SEARCH,
} from '~/constants/pages.constant'

// Hooks
import {useMedia} from '~/hooks'

import menuItems from './menuItems'

const NONE_BANNER_PATHS = [
  BLOG_DETAILS,
  BLOG_LIST,
  DETAILS,
  SEARCH,
  SALE_PAGE,
  SALE_BY_DISTRICT,
  RENT_PAGE,
  RENT_BY_DISTRICT,
  CATEGORY,
  CONSIGNMENT,
  NOT_FOUND,
]

const HeaderComponent = (props) => {
  const {
    pageName,
  } = props

  const [isNavShow, setNavStatus] = useState(false)

  const handleNavToggle = useCallback(() => {
    setNavStatus((prevState) => !prevState)
  }, [setNavStatus])

  const isMobile = useMedia(['(max-width: 767.98px)'], [true], false)

  const [showSubmenus, setShowSubMenus] = useState({})
  const toggleSubMenu = (idx) => () => setShowSubMenus(
    produce((draftState) => {
      draftState[idx] = !draftState[idx]
    }),
  )

  return (
    <Header>
      <Header.ContactAndSocialLinks>
        <Header.Contact>
          <Header.ContactItem href='mailto:pthnga0908@gmail.com'>
            <Header.ContactItemIcon>
              <FaEnvelope />
            </Header.ContactItemIcon>

            <Header.ContactItemValue>pthnga0908@gmail.com</Header.ContactItemValue>
          </Header.ContactItem>

          <Header.ContactItem href='tel:0978800347'>
            <Header.ContactItemIcon>
              <FaPhone />
            </Header.ContactItemIcon>

            <Header.ContactItemValue>0978 800 347</Header.ContactItemValue>
          </Header.ContactItem>
        </Header.Contact>

        <Header.SocialLinks>
          <Header.SocialLinkItem href='https://www.facebook.com/ms.ngabds/'>
            <FaFacebookF />
          </Header.SocialLinkItem>

          <Header.SocialLinkItem href='https://www.youtube.com/channel/UCe_3q-XcapV110uKJECP5ww'>
            <FaYoutube />
          </Header.SocialLinkItem>

          {/* <Header.SocialLinkItem href='#'>
            <FaLinkedinIn />
          </Header.SocialLinkItem>

          <Header.SocialLinkItem href='#'>
            <FaInstagram />
          </Header.SocialLinkItem> */}
        </Header.SocialLinks>

      </Header.ContactAndSocialLinks>

      <Header.LogoAndNavAndContactUs>
        <Header.LogoWrapper to='/'>
          <Header.Logo
            width={226}
            height={60}
            src='https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,h_60,w_226/v1617419748/static-images/ngabds-logo-1.png'
            srcSet='
                https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,h_60,w_226/v1617419748/static-images/ngabds-logo-1.png 226w,
                https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto,h_120,w_452/v1617419748/static-images/ngabds-logo-1.png 452w,
              '
            sizes='226px'
            alt='NgaBDS logo'
          />
        </Header.LogoWrapper>

        <Header.NavAndContactUs>
          <Header.Nav show={isNavShow}>
            {menuItems.map((item, index) => {
              const hasChildren = !!item.children
              const isActive = includes(item.activePaths, pageName)
              const showSubMenu = showSubmenus[index]

              const renderItem = () => (
                <Header.NavItem
                  key={index}
                  {...{
                    hasChildren,
                    showSubMenu,
                  }}
                >
                  <Header.NavLink
                    to={item.to}
                    className={cn({
                      active: isActive,
                    })}
                  >
                    {item.text}
                  </Header.NavLink>

                  {isMobile && hasChildren && <Header.Arrow {...{showSubMenu}} onClick={toggleSubMenu(index)} />}

                  {hasChildren && (
                    <Header.NavItemsLv2Wrapper>
                      {item.children.map((child, childIndex) => (
                        <Header.NavItemLv2 key={childIndex} to={child.to}>{child.text}</Header.NavItemLv2>
                      ))}
                    </Header.NavItemsLv2Wrapper>
                  )}
                </Header.NavItem>
              )

              return renderItem()
            })}

            <Header.CloseNavBtn onClick={handleNavToggle} />
          </Header.Nav>

          <Header.ContactUs href='#contact'>Contact us</Header.ContactUs>
        </Header.NavAndContactUs>

        <Header.NavToggler onClick={handleNavToggle} />
      </Header.LogoAndNavAndContactUs>

      {!includes(NONE_BANNER_PATHS, pageName) && process.env.NODE_ENV !== 'development' && <Header.Banner />}
    </Header>
  )
}

export default HeaderComponent
